export function setImpersonationHeaders(headers) {
  if(localStorage.getItem("isImpersonated")) {
    headers.set("isImpersonated", true);
    headers.set("impersonatedUser", localStorage.getItem("IMP_extension_ContactID"))
  }
  return headers
}